/**
 * Portal Manta · SectionCollapse
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V, S } from '../../globals.js';

function SectionCollapse({id,titulo,defOpen,children}){
  const [open,setOpen] = useState(defOpen!==false);
  return(<div style={{marginBottom:open?14:6}}>
    <div onClick={()=>setOpen(!open)} style={{
      display:'flex',alignItems:'center',gap:8,padding:'7px 10px',cursor:'pointer',
      background:open?V.g0:'#fff',border:'1px solid '+V.b1,borderRadius:open?'6px 6px 0 0':6,
      borderBottom:open?'1px solid '+V.b1:'1px solid '+V.b1,transition:'all .12s'}}>
      <span style={{fontSize:10,color:V.gr,fontWeight:700}}>{open?'▼':'▶'}</span>
      <span style={S.h2}>{titulo}</span>
    </div>
    {open && <div style={{padding:'10px 0 0 0'}}>{children}</div>}
  </div>);
}

export { SectionCollapse };
export default SectionCollapse;
